module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9598.ce2577c9.jpg";